import React from 'react';
import { motion } from "framer-motion";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faEnvelope } from '@fortawesome/free-solid-svg-icons';

const AccountInfo = ({ 
  email, 
  profile, 
  loginType, 
  theme 
}) => {
  const styles = {
    card: {
      background: theme?.background?.card || theme?.backgrounds?.card,
      borderRadius: '1.25rem',
      padding: '2rem',
      border: `1px solid ${theme?.borders?.primary}`,
      boxShadow: theme?.shadows?.base,
      marginBottom: '1.5rem',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    content: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    },
    header: {
      textAlign: 'center',
      marginBottom: '2rem',
    },
    infoCard: {
      background: theme?.primary?.gray?.[100],
      border: `1px solid ${(theme?.primary?.blue?.[200] || theme?.borders?.primary) + '60'}`,
      borderRadius: '1rem',
      paddingLeft: '1.5rem',
      paddingRight: '1.5rem',
      paddingTop: '.5rem',
      flex: 1,
    },
    infoRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
      marginBottom: '.5rem',
    },
    infoLabel: {
      fontSize: '0.875rem',
      fontWeight: '600',
      color: theme?.text?.secondary,
      minWidth: '120px',
    },
    infoValue: {
      fontSize: '1rem',
      color: theme?.text?.primary,
      fontWeight: '500',
    },
  };

  return (
    <motion.div
      style={styles.card}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.1 }}
    >
      <div style={styles.content}>
        <div style={styles.header}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '700',
            color: theme?.text?.primary,
            marginBottom: '0.5rem'
          }}>
            Account Information
          </h2>
          <p style={{
            fontSize: '0.875rem',
            color: theme?.text?.secondary
          }}>
            Your account details and login information
          </p>
        </div>

        <div style={styles.infoCard}>
          <div style={styles.infoRow}>
            <FontAwesomeIcon 
              icon={faEnvelope} 
              style={{ color: theme?.primary?.blue?.[500] || theme?.ui?.primary }}
            />
            <span style={styles.infoLabel}>Email:</span>
            <span style={styles.infoValue}>{email ? email : profile?.auth_email}</span>
          </div>
          <div style={styles.infoRow}>
            <FontAwesomeIcon 
              icon={faUser} 
              style={{ color: theme?.primary?.blue?.[500] || theme?.ui?.primary }}
            />
            <span style={styles.infoLabel}>Login Method:</span>
            <span style={styles.infoValue}>{loginType}</span>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default AccountInfo;
